module.exports = __webpack_public_path__ + "static/media/workshop.538eacf0.svg";